module.exports = {
    config: {
        isCacheable: false
    }
}